export default __webpack_public_path__ + "static/media/ce9a54c19f34a00673e3e319082b07e31576755821797.c2d712d6.webp";